<template>
  <tbody class="list fs-base">
    <slot></slot>
  </tbody>
</template>
